import script from "./login.vue?vue&type=script&setup=true&lang=js"
export * from "./login.vue?vue&type=script&setup=true&lang=js"

import "./login.vue?vue&type=style&index=0&id=30a083b8&scoped=true&lang=less"

import exportComponent from "E:\\A-OnlineServiceCenter\\stableBuilds\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30a083b8"]])

export default __exports__